export default "/images/8797465e31514e56406c4a8af5813e46.avif";